import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  paper: {
    width: "560px !important",
  },
  body: {
    width: "100%",
  },
}));

export default styles;
